import noop from "lodash/noop";

import loadScript from '../utils/load-script';
import { userData } from "./user-data";
import { rodo } from '../../../shared/components/rodo/rodo';
import documentReady from '../utils/document-ready';


export class Analytics {
  constructor(analyticsId) {
    this.analyticsId = analyticsId;
  }

  attachEvents() {
    const ANALYTICS_SELECTOR = "data-analytics";

    document.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute(ANALYTICS_SELECTOR)) {
        const data = JSON.parse(e.target.getAttribute(ANALYTICS_SELECTOR));

        const eventSet = data.set;
        const eventData = data.event;

        const [category, action, label, value] = eventData;

        if (category && action) {
          if (eventSet) {
            ga("set", eventSet);
          }

          ga("send", "event", {
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value,
            transport: "beacon",
          });
        }
      }
    });
  }

  load() {
    window.ga = window.ga || function () { (ga.q = ga.q || []).push(arguments) }; ga.l = +new Date;
    ga('create', this.analyticsId, 'auto');
    ga('send', 'pageview');

    loadScript("https://www.google-analytics.com/analytics.js");

    userData.getData().then(data => {
      if (!data.user || !data.user.id) {
        return
      }

      this.setUserId(data.user.id);
    }).catch(noop);
  }

  setUserId(userId) {
    ga("set", "userId", userId);
    ga('send', 'event', 'Authentication', 'UserID Available');
  }

  init() {
    if (!this.analyticsId) {
      return;
    }

    this.load();
    this.attachEvents();
  }
}

export const analytics = new Analytics(App.Contants.ANALYTICS_ID);

documentReady(() => {
  rodo.acceptedPromise.then(() => {
    analytics.init();
  }).catch(noop)
});
